export const isContactRemoved = (contact) => contact.metadata.removed === true;
export const isContactInactive = (contact) => contact.metadata.inactive === true;
export const isContactActive = (contact) => !isContactInactive(contact) && !isContactRemoved(contact);
